import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import DialogTitle from '@mui/material/DialogTitle';
import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";
momentDurationFormatSetup(moment);
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { useRef } from 'react';
import { useRootStore } from '../hooks/useRootStore';
import { MDXEditor, MDXEditorMethods } from '@mdxeditor/editor';
import { MdxPlugins } from './MarkdownEditor/MarkdownEditorPlugins';
import MarkdownView from './MarkdownView';
import useDeviceMedia from '../hooks/useDeviceMedia';

export default function IssueResultDialog({ issueId, assignedEmployeeId, result, onSubmit, onCancel }: { issueId: number, assignedEmployeeId: number, result: string, onSubmit: (newResult: string) => void, onCancel: () => void }) {
    const { api, userProfile } = useRootStore();
    const { isMobile } = useDeviceMedia();

    const mdxEditorRef = useRef<MDXEditorMethods>(null);

    const postResult = async () => {
        const newResult = (mdxEditorRef.current?.getMarkdown() ?? '')//.trim();
        await api
            .postIssueResult(issueId, newResult).then(() => onSubmit(newResult));
    }

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <Dialog
                maxWidth='lg'
                fullWidth
                open={true}
                onClose={(_event, reason) => {
                    if (!(reason && reason === "backdropClick"))
                        onCancel();
                }}
            >
                <DialogTitle>Описание результата</DialogTitle>
                {isMobile ? '' : <HighlightOffOutlinedIcon sx={{ position: 'absolute', right: 10, top: 10, cursor: 'pointer' }} onClick={onCancel} />}
                <DialogContent sx={{ minHeight: '350px', padding: '0px 10px' }} onClick={() => mdxEditorRef.current?.focus()}>
                    {userProfile?.ID == assignedEmployeeId ?
                        <MDXEditor
                            ref={mdxEditorRef}
                            markdown={result ?? ''}
                            plugins={MdxPlugins.standardPlugins(api, issueId, '', isMobile)}
                        />
                        : <MarkdownView markup={result ?? ''} />
                    }
                </DialogContent>
                {userProfile?.ID == assignedEmployeeId ?
                    <DialogActions>
                        <Button onClick={onCancel}>Отмена</Button>
                        <Button onClick={postResult}>Сохранить</Button>
                    </DialogActions>
                    : ''
                }
            </Dialog>
        </LocalizationProvider>
    );
}